import React, {useEffect, useState} from 'react';
import {ScrollView, FlatList, Platform, Linking, Text, Modal} from 'react-native';
import {useDispatch, useSelector} from 'react-redux';
import {useFocusEffect} from '@react-navigation/native';
import {useWindowDimensions} from "../../hooks/useWindowDimensions";
import {fetchLatestWorkout} from '../../reducers/cbcWorkoutSlice';
import LifeStyleRow from "./LifeStyleRow";
import Bugsnag from "@bugsnag/expo";
import DynamicModal from "../../modals/DynamicModal";
import ReminderBanner from "../ReminderBanner";
import TodaysWorkout from "./TodaysWorkout";
import WorkoutScience from "./WorkoutScience";
import WorkoutStreak from "./workout-streak/WorkoutStreak";
import WorkoutStats from "./workout-stats/WorkoutStats";
import WorkoutTrainingPlan from "./training-plan/WorkoutTrainingPlan";

import {
    WorkoutContainerText,
    WorkoutContainerHeaderThree,
    WorkoutTextSubHeader,
    WorkoutTextHeader,
} from '../../styles/common-styles';
import {fetchLatestActivityScores} from "../../reducers/cbcActivityScoresSlice";
import styled from "styled-components/native";
import PractitionerRow from "./PractitionerRow";
import AdminRow from "./AdminRow";
import PushNotificationHandler from "../PushNotificationHandler";

function WorkoutDashboard(props) {
    const [modalVisible, setModalVisible] = useState(false); // State to manage modal visibility
    const {current_workout} = useSelector((state) => state.cbcWorkout);
    const {
        userId,
        wpAuthorizationToken,
        authLoading,
        authResultMessage,
        apiAuthToken,
    } = useSelector((state) => state.cbcAuthorization)



    Bugsnag.leaveBreadcrumb('On workout dashboard');
    var onLayout;

    if (Platform.OS == 'web') {
        const [dimensions, setDimensions] = useState({width: 0, height: 0});

        onLayout = (event) => {
            const {width, height} = event.nativeEvent.layout;
            setDimensions({width, height});
        };

        useEffect(() => {
            if (window.parent !== window && dimensions.height >= 150) {
                window.parent.postMessage(
                    {
                        height: dimensions.height,
                    },
                    '*'
                );
            }
        }, [dimensions]);
    }

    const {width} = useWindowDimensions();
    const dispatch = useDispatch();
    const {activity_scores, core_focuses} = useSelector(
        (state) => state.activityScores
    ); // Select the activities from state

    useFocusEffect(
        React.useCallback(() => {
            Bugsnag.notify(`${userId}
                ${wpAuthorizationToken},
                ${authLoading},
                ${authResultMessage},
                ${apiAuthToken}`);
            dispatch(fetchLatestWorkout({}));
            dispatch(fetchLatestActivityScores(userId));
        }, [])
    );

    return (
        <ScrollView style={{backgroundColor: '#fff'}} onLayout={onLayout}>
            <PushNotificationHandler userId='47' />
            <DynamicModal/>
            <WorkoutDashboardRow
                screenWidth={width}
                style={{backgroundColor: '#f8f9fb'}}
            >
                {Platform.OS !== 'web' && (
                    <ReminderBanner/>
                )}
                <TodaysWorkout
                    screenWidth={width}
                    navigation={props.navigation}
                    userId={userId}
                />
                <WorkoutScience screenWidth={width}/>
            </WorkoutDashboardRow>

            <WorkoutDashboardRow screenWidth={width}>
                <WorkoutStreak user_id={userId}></WorkoutStreak>
                <WorkoutStats activities={activity_scores}></WorkoutStats>
                <WorkoutTrainingPlan coreFocuses={core_focuses}></WorkoutTrainingPlan>
            </WorkoutDashboardRow>
            { Platform.OS !== 'web' &&
                <LifeStyleRow navigation={props.navigation}/>
            }
            <PractitionerRow navigation={props.navigation}/>
            <AdminRow navigation={props.navigation}/>


        </ScrollView>
    );
}


export const WorkoutDashboardRow = styled.View`
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  background: #ffffff;
  justify-content: space-evenly;
  align-items: center;
  padding-bottom: 30px;
  height: auto;
  flex-wrap: wrap;
  flex-direction: row;
`;

export default WorkoutDashboard;
